/* Vloerenthuis — winkelwagen via de Shopify AJAX-API */
document.head.insertAdjacentHTML("beforeend", "<style>body{margin:0}</style>");
window.VT = (() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const map = h => {
    let m;
    if ((m = h.match(/^sample-klik-pvc-(.+)-eiken-walvisgraat$/))) return "testpak-walvisgraat-" + m[1];
    if ((m = h.match(/^sample-klik-pvc-(.+)-tegel$/))) return "testpak-pvc-tegels-" + m[1];
    if ((m = h.match(/^sample-(.+)-eiken-visgraat$/))) return "testpak-visgraat-" + m[1];
    if ((m = h.match(/^sample-(.+)-eiken-extra-breed$/))) return "testpak-brede-planken-" + m[1];
    return h;
  };
  const json = (url, body) => fetch(root + url, body ? {method: "POST", headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify(body)} : {headers: {"Accept": "application/json"}}).then(r => { if (!r.ok) throw new Error(url + " " + r.status); return r.json(); });
  const cart = () => json("cart.js");
  const paint = n => {
    const hc = document.getElementById("hcartN"); if (hc) { hc.hidden = !n; hc.textContent = n; }
    const b = document.getElementById("bag"); if (!b) return;
    b.hidden = !n;
    const N = document.getElementById("bagN"); if (N) N.textContent = n;
    const s = b.querySelector("span"); if (s) s.textContent = "Winkelwagen";
  };
  const bump = () => { const b = document.getElementById("bag"); if (b) { b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump"); } };
  const count = () => cart().then(c => { paint(c.items.length); return c; });
  async function add(h, q) {
    const handle = map(h);
    const c = await cart();
    if (handle.indexOf("testpak-") === 0 && c.items.some(i => i.handle === handle)) return count();
    const p = await json("products/" + handle + ".js");
    await json("cart/add.js", {items: [{id: p.variants[0].id, quantity: q || 1}]});
    const n = await count(); bump(); return n;
  }
  async function remove(h) {
    const handle = map(h), c = await cart(), it = c.items.find(i => i.handle === handle);
    if (it) await json("cart/change.js", {id: it.key, quantity: 0});
    return count();
  }
  document.addEventListener("DOMContentLoaded", () => {
    count().catch(() => {});
    const b = document.getElementById("bag");
    if (b && !document.getElementById("cartd")) { b.style.cursor = "pointer"; b.setAttribute("role", "link"); b.addEventListener("click", () => { location.href = root + "cart"; }); }
  });
  return {add, remove, cart, count, map};
})();
